import React from "react";
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {I18nextProvider} from "react-i18next";
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import {isbot} from "isbot";
import {v4 as uuidv4} from "uuid";
import {mergeDeep, setRegister, setSession, setTrack} from "utils";
import {LanguageEnum, LandingEnum, LandingRelationsEnum} from "_business";
import {resetMixpanel} from "utils/mixpanel"
import {sha256} from "js-sha256";
import Cookies from "js-cookie";
import 'reportWebVitals'

window.session_uid = window.sessionStorage.getItem('session_uid')
window.landing = window.sessionStorage.getItem('landing') || LandingEnum.charisma

const matched = window.location.href.match(
  new RegExp(`/(${Object.values(LandingEnum).join('|')})(?:/|[?#].*|$)`)
)

if (matched && matched.length > 1)
  window.landing = matched[1]

const options = {
  fallbackLng: 'en',
  defaultNS: 'common',
  debug: process.env.REACT_APP_DEBUG,
  interpolation: {escapeValue: false},  // React already does escaping
  resources: {},
}

if (
  [`/${window.landing}`, `/${window.landing}/`].includes(window.location.pathname) &&
  window.sessionStorage.getItem('landing') && window.sessionStorage.getItem('landing') !== window.landing
)
  resetMixpanel()

window.sessionStorage.setItem('landing', window.landing)

for (const lang in LanguageEnum) {
  if (
    !LandingRelationsEnum[window.landing] ||
    LandingRelationsEnum[window.landing].includes(lang)
  ) {
    options.resources[lang] = {
      common: mergeDeep(
        require(`assets/i18/${lang}/common.json`),
        require(`module/${window.landing}/assets/i18/${lang}/common.json`)
      ),
      survey: require(`module/${window.landing}/assets/i18/${lang}/survey.json`),
    }
  }
}

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(options, (err, t) => {
    if (err)
      console.error('error while initialising i18next ::: ' + JSON.stringify(err))
  })


// const
//   isLightVersion = isIndia() && window.landing === LandingEnum.default,
//   font = 'https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700&display=swap',
//   arFont = 'https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap',
//   arCss = '/static/css/ar.css'

const langCallback = (lang) => {
  document.documentElement.lang = lang
  document.title = i18n.t('meta.title')

  // if (
  //   lang === 'ar' && (
  //     !LandingRelationsEnum[window.landing] ||
  //     LandingRelationsEnum[window.landing].includes(lang)
  //   )
  // ) {
  //   document.documentElement.setAttribute('dir', 'rtl')
  //
  //   if (!isLightVersion) {
  //     document.querySelector(`link[href="${font}"]`)?.remove()
  //     loadCss(arFont)
  //   }
  //
  //   loadCss(arCss)
  // } else {
  //   document.documentElement.removeAttribute('dir')
  //
  //   if (!isLightVersion) {
  //     document.querySelector(`link[href="${arFont}"]`)?.remove()
  //     loadCss(font)
  //   }
  //
  //   document.querySelector(`link[href="${arCss}"]`)?.remove()
  // }

  const metaDescr = document.querySelector('meta[name="description"]')
  metaDescr.setAttribute('content', i18n.t('meta.description'))
}

langCallback(i18n.resolvedLanguage)

i18n.on('languageChanged', (lang) => {
  langCallback(lang)
})

setRegister({
  version: process.env.REACT_APP_VERSION,
  isbot: isbot(navigator.userAgent),
  lang: i18n.resolvedLanguage,
  landing: window.landing,
})

if (!window.session_uid) {
  // console.log({page: 'start'})

  // if (window.landing === LandingEnum.default) {
  //   getExperiment('A80')
  // }

  setRegister({
    load_time_ms: Math.round(performance.now() - (window.__appStartTime || 0))
  })
  setTrack('start')

  const
    params = new URLSearchParams(window.location.search),
    clickId = params.get('reddit_click_id') || params.get('rdclid'),
    ttclid = params.get('ttclid') || params.get('tt_test_id'),
    qclid = params.get('qclid'),
    msclkid = params.get('msclkid')

  if (clickId)
    window.localStorage.setItem('rdclid', clickId)

  if (ttclid)
    window.localStorage.setItem('ttclid', ttclid)

  if (qclid)
    window.localStorage.setItem('qclid', qclid)

  if (msclkid) {
    window.localStorage.setItem('msclkid', msclkid)
    Cookies.set('_uetmsclkid', msclkid, {
      expires: 90,
      domain: '.vocalimage.net',
      path: '/',
    })
  }

  if (params.get('session_uid')) {
    window.session_uid = params.get('session_uid')
    window.sessionStorage.setItem('session_uid', window.session_uid)
  } else {
    window.session_uid = uuidv4()
    setSession({lang: i18n.resolvedLanguage})
  }
}

if (window.ttq)
  window.ttq.identify({
    email: window.localStorage.getItem('email') || '',
    sha256_email: window.localStorage.getItem('email') ? sha256(window.localStorage.getItem('email')) : '',
    sha256_phone_number: '',
    // external_id: sha256(Cookies.get('ttclid') || window.localStorage.getItem('ttclid') || window.session_uid),
    external_id: sha256(window.session_uid),
  })


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        {/*<MixpanelProvider mixpanel={mixpanel}>*/}
          <App/>
        {/*</MixpanelProvider>*/}
      </BrowserRouter>
    </I18nextProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()